import React from "react";
const paymentMethods = [{
  name: "Visa",
  src: "https://cdn.simpleicons.org/visa/1A1F71"
}, {
  name: "Mastercard",
  src: "https://cdn.simpleicons.org/mastercard/EB001B"
}, {
  name: "American Express",
  src: "https://cdn.simpleicons.org/americanexpress/2E77BC"
}, {
  name: "Apple Pay",
  src: "https://cdn.simpleicons.org/applepay/000000"
}];
export function PaymentMethods() {
  return <div className="mt-4" aria-label="Métodos de pago aceptados" data-id="element-148" data-mp="36ttrvz05r2qm">
      <p className="text-center text-[11px] font-semibold uppercase tracking-wide text-slate-400" data-id="element-149" data-mp="36v4v9xpoy8h7">
        Pago seguro con
      </p>
      <div className="mt-2 flex items-center justify-center gap-2" data-id="element-150" data-mp="2y0grkbzrkyui">
        {paymentMethods.map(method => <div key={method.name} className="flex h-8 min-w-[52px] items-center justify-center rounded-md border border-slate-200 bg-white px-2.5 shadow-sm" data-id="element-151" data-mp="2t2opwq9bhyd4">
            <img src={method.src} alt={method.name} className="h-4 w-auto max-w-[48px] object-contain" data-id="element-152" data-mp="2j3fvjwajihq8" />
          </div>)}
      </div>
    </div>;
}